import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  readonly isDark$ = new BehaviorSubject<boolean>(false);
  readonly darkRequested$ = new Subject<boolean>();

  setDark(dark: boolean) {
    this.darkRequested$.next(dark);
  }
}
